export default () => ({
  handleResize: null,
  handleImage: null,
  resizeObserver: null,
  rebuildTimer: null,
  destroyed: false,

  init() {
    this.$nextTick(() => {
      if (this.destroyed) return;
      const track = this.$refs.track;
      const viewport = this.$refs.viewport;
      if (!track || !viewport) return;

      this.handleResize = () => this.scheduleBuild();
      this.handleImage = event => {
        if (!event.target.closest('[data-marquee-clone]')) this.scheduleBuild();
      };
      track.addEventListener('load', this.handleImage, true);
      track.addEventListener('error', this.handleImage, true);
      window.addEventListener('resize', this.handleResize);

      this.resizeObserver = new ResizeObserver(() => this.scheduleBuild());
      this.resizeObserver.observe(viewport);
      Array.from(track.children).forEach(item => {
        if (!item.hasAttribute('data-marquee-clone')) this.resizeObserver.observe(item);
      });
      this.build();
    });
  },

  scheduleBuild() {
    if (this.destroyed) return;
    clearTimeout(this.rebuildTimer);
    this.rebuildTimer = setTimeout(() => {
      if (!this.destroyed) this.build();
    }, 150);
  },

  destroy() {
    this.destroyed = true;
    clearTimeout(this.rebuildTimer);
    this.resizeObserver?.disconnect();
    window.removeEventListener('resize', this.handleResize);
    const track = this.$refs.track;
    if (track && this.handleImage) {
      track.removeEventListener('load', this.handleImage, true);
      track.removeEventListener('error', this.handleImage, true);
    }
    this.reset();
  },
  reset() {
    const track = this.$refs.track;

    if (!track) {
      return;
    }

    track.classList.remove('is-ready');
    track.style.removeProperty('--marquee-distance');
    track.style.removeProperty('--marquee-duration');

    track.querySelectorAll('[data-marquee-clone]').forEach((node) => node.remove());
  },

  build() {
    const viewport = this.$refs.viewport;
    const track = this.$refs.track;

    if (this.destroyed || !viewport || !track) {
      return;
    }

    this.reset();
    const originalItems = Array.from(track.children).filter(
      (item) => !item.hasAttribute('data-marquee-clone')
    );

    if (!originalItems.length) {
      return;
    }

    const viewportWidth = viewport.getBoundingClientRect().width;
    if (viewportWidth <= 0) return;

    originalItems.forEach((item) => {
      const clone = item.cloneNode(true);
      clone.setAttribute('data-marquee-clone', 'true');
      clone.setAttribute('aria-hidden', 'true');
      clone.querySelectorAll('a').forEach(link => link.setAttribute('tabindex', '-1'));
      track.appendChild(clone);
    });

    const firstOriginal = originalItems[0];
    const firstClone = track.querySelector('[data-marquee-clone]');

    if (!firstOriginal || !firstClone) {
      return;
    }

    const loopDistance = firstClone.offsetLeft - firstOriginal.offsetLeft;

    if (loopDistance <= 0) {
      this.reset();
      return;
    }

    const extraSets = Math.ceil(viewportWidth / loopDistance);
    for (let set = 0; set < extraSets && track.scrollWidth < viewportWidth + loopDistance; set++) {
      originalItems.forEach((item) => {
        const clone = item.cloneNode(true);
        clone.setAttribute('data-marquee-clone', 'true');
        clone.setAttribute('aria-hidden', 'true');
        clone.querySelectorAll('a').forEach(link => link.setAttribute('tabindex', '-1'));
        track.appendChild(clone);
      });
    }

    const speed = 80;
    const duration = loopDistance / speed;

    track.style.setProperty('--marquee-distance', `${loopDistance}px`);
    track.style.setProperty('--marquee-duration', `${duration}s`);
    track.classList.add('is-ready');
  },

});
